export const ADMIN_COMPANY_ID = 'ea5befd8-958c-466e-96b5-a8513a0c416e';
